import { Injectable } from '@angular/core';

declare var gtag: any;

@Injectable({providedIn: 'root'})
export class AnalyticsService {

  pageView(pageLocation: string, pageTitle: string) {
    gtag('event', 'page_view', {
      'page_location': pageLocation,
      'page_title': pageTitle
    });
  }

  trackEvent(eventName: string, eventDetails: string, eventCategory: string) {
    gtag('event', eventName, {
      'Event_Category': eventCategory,
      // the label that will show up in the dashboard as the events name
      'Event_Label': eventName,
      'Event_Action': eventDetails
    });
  }
}
